<div class="layout">
  <app-menu class="menu"></app-menu>
  <app-map class="map"></app-map>
  <router-outlet />
</div>
